import { clientsTasksListOptions, ReturnTaskReadable } from '@crm/api'
import { DayLabel, TableContainer } from '@shared/components'
import { useQueryParams } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { useQuery } from '@tanstack/react-query'
import { Button, Flex, TableColumnsType } from 'antd'
import { Add } from 'iconsax-react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { AddClientTask } from './AddClientTask'

export const ClientTasksCol = () => {
  const { t } = useLocales()
  const { id } = useParams()
  const params = useQueryParams()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { data, isLoading } = useQuery({
    ...clientsTasksListOptions({
      path: { client_id: id! },
      query: { ...params }
    }),
    enabled: !!id
  })

  const columns: TableColumnsType<ReturnTaskReadable> = [
    { title: t('task.title'), dataIndex: 'title', key: 'title' },
    {
      title: t('task.owner'),
      key: 'owner',
      render: (_, record) =>
        [record.owner?.first_name, record.owner?.last_name]
          .filter(Boolean)
          .join(' ') || '-'
    },
    {
      title: t('task.priority'),
      dataIndex: 'priority',
      key: 'priority'
    },
    {
      title: t('task.close_date'),
      dataIndex: 'deadline',
      key: 'deadline',
      render: (date) => <DayLabel date={date} />
    }
  ]

  return (
    <Flex vertical gap={16}>
      <TableContainer
        rowKey="id"
        columns={columns}
        data={data}
        loading={isLoading}
        rightChildren={
          <Button
            type="primary"
            icon={<Add size={16} />}
            onClick={() => setIsModalOpen(true)}
          >
            {t('task.add_task')}
          </Button>
        }
      />

      {isModalOpen && (
        <AddClientTask open onCancel={() => setIsModalOpen(false)} />
      )}
    </Flex>
  )
}
